
export const Auth0TokenProvider = () => {
    const env = process.env;
    const getAuth0IdTokenClaims = () => {

        let data = "";
        try {
            data = JSON.parse(localStorage.getItem("@@auth0spajs@@::" + env.AUTH0_CLIENT_ID + "::default::openid profile email"))
        } catch (e) { }
        return data && data.body && data.body.id_token ? data.body.id_token : "";
    }

    const getAuth0TokenExpiresAt = () => {
        let data = "";
        try {
            data = JSON.parse(localStorage.getItem("@@auth0spajs@@::" + env.AUTH0_CLIENT_ID + "::default::openid profile email"))
        } catch (e) { }
        return data && data.expiresAt ? data.expiresAt : "";
    }

    const getAuth0UserDetails = () => {


        let data = "";
        try {
            data = JSON.parse(localStorage.getItem("@@auth0spajs@@::" + env.AUTH0_CLIENT_ID + "::default::openid profile email"))
        } catch (e) { }
        let userDetails = data && data.body && data.body.decodedToken && data.body.decodedToken.user && data.body.decodedToken.user.email ? data.body.decodedToken.user.email : ""
        return userDetails;
    }
    return {
        getAuth0IdTokenClaims: getAuth0IdTokenClaims,
        getAuth0TokenExpiresAt: getAuth0TokenExpiresAt,
        getUserDetails: getAuth0UserDetails
    }

}